
import { loadCiceroFromSpec } from '../cicero/cicero.js';
import { compilerCiceroToFronto } from '../cicero-fronto/compile.js';
import { renderFronto } from '../fronto/fronto.js'


export async function convert(sourceSpec, ciceroSpec, config) {
  // convert from cicero to fronto; jsut a wrapper for cicero-fronto
  let ciceroObj = await loadCiceroFromSpec(ciceroSpec, sourceSpec, compilerCiceroToFronto, renderFronto);
  let converted = await ciceroObj.getTransformed(); // converted Fronto
  return converted;
}